/* unplugin-vue-components disabled */import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-287da9ae"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  key: 0
};
var _hoisted_2 = {
  class: "bg"
};
var _hoisted_3 = {
  style: {
    "text-align": "center",
    "margin-top": "20px"
  }
};
var _hoisted_4 = {
  key: 1,
  class: "fixedInfo"
};
var _hoisted_5 = {
  class: "main"
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "添加保养记录", -1);
});
var _hoisted_7 = {
  style: {
    "padding": "20px 10px"
  }
};
var _hoisted_8 = {
  class: "row"
};
var _hoisted_9 = {
  class: "row"
};
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "保养内容：", -1);
});
var _hoisted_11 = {
  class: "row"
};
var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "保养人员：", -1);
});
var _hoisted_13 = {
  class: "row"
};
var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "备注信息：", -1);
});
var _hoisted_15 = {
  class: "row"
};
var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "下次保养：", -1);
});
import { showToast } from 'vant';
import hyRequest from '@/service';
import { Step, Steps } from 'vant';
export default {
  __name: 'Maintenance',
  setup: function setup(__props) {
    var device_id = useRoute().query.device_id;
    var device_name = useRoute().query.deviceName;
    var List = ref([]);
    function getData() {
      hyRequest.post({
        url: '/repair/maintainRecordByDeviceId',
        data: {
          device_id: device_id,
          pageNumber: 1,
          pageSize: 20000
        }
      }).then(function (data) {
        List.value = data.list;
      });
    }
    getData();

    // const today = dayjs().format('YYYY-MM-DD');
    var show = ref(false);
    var saveType = ref('insert');
    var form = reactive({
      id: '',
      device_id: device_id,
      device_name: device_name,
      next_time: '',
      info: '',
      remark: ''
    });

    // function edit(item) {
    //   saveType.value = 'update';
    //   form.id = item.id;
    //   form.next_time = dayjs(item.next_time).format('YYYY-MM-DD');
    //   form.info = item.info;
    //   form.remark = item.remark;
    //   defaultDay.value = dayjs(item.next_time).toDate();
    //   show.value = true;
    // }

    // function remove(id) {
    //   console.log(id);
    //   hyRequest
    //     .post({
    //       url: '/repair/maintainDel',
    //       data: {
    //         id
    //       }
    //     })
    //     .then(() => {
    //       showToast('删除成功！');
    //       getData();
    //     });
    // }

    function openDialog() {
      form.next_time = '';
      form.info = '';
      form.remark = '';
      show.value = true;
      saveType.value = 'insert';
    }
    var showDate = ref(false);
    var defaultDay = ref(dayjs().toDate());
    function onConfirm(e) {
      showDate.value = false;
      form.next_time = dayjs(e).format('YYYY-MM-DD');
    }
    function cancel() {
      show.value = false;
    }
    function saveData() {
      if (form.next_time == '') {
        return showToast('请设置下次保养时间');
      }
      var url = '';
      if (saveType.value == 'insert') {
        url = '/repair/maintainAdd';
      } else {
        url = '/repair/maintainEdit';
      }
      hyRequest.post({
        url: url,
        data: form
      }).then(function () {
        show.value = false;
        showToast('保存成功');
        getData();
      });
    }
    if (useRoute().query.add == 1) {
      openDialog();
    }
    return function (_ctx, _cache) {
      var _component_van_field = _resolveComponent("van-field");
      var _component_van_button = _resolveComponent("van-button");
      var _component_van_icon = _resolveComponent("van-icon");
      var _component_van_calendar = _resolveComponent("van-calendar");
      return _openBlock(), _createElementBlock("div", null, [_unref(show) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "wrapper",
        onClick: _cache[4] || (_cache[4] = _withModifiers(function () {}, ["stop"]))
      }, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_field, {
        modelValue: _unref(form).info,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _unref(form).info = $event;
        }),
        label: "保养内容",
        "label-width": "auto",
        colon: "",
        type: "textarea",
        placeholder: "请输入保养内容"
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        modelValue: _unref(form).remark,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return _unref(form).remark = $event;
        }),
        label: "备注信息",
        "label-width": "auto",
        colon: "",
        type: "textarea",
        placeholder: "请输入备注信息"
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        modelValue: _unref(form).next_time,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
          return _unref(form).next_time = $event;
        }),
        label: "下次保养",
        colon: "",
        readonly: "",
        type: "textarea",
        "label-width": "auto",
        placeholder: "请设置下次保养日期"
      }, {
        button: _withCtx(function () {
          return [_createVNode(_component_van_button, {
            size: "mini",
            plain: "",
            type: "primary",
            icon: "add-o",
            style: {
              "position": "absolute",
              "top": "0",
              "right": "0"
            },
            onClick: _cache[2] || (_cache[2] = function ($event) {
              return showDate.value = true;
            })
          }, {
            default: _withCtx(function () {
              return [_createTextVNode("选择日期")];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_van_button, {
        type: "warning",
        size: "small",
        onClick: cancel,
        style: {
          "width": "80px"
        }
      }, {
        default: _withCtx(function () {
          return [_createTextVNode("取消")];
        }),
        _: 1
      }), _createVNode(_component_van_button, {
        type: "primary",
        size: "small",
        style: {
          "margin-left": "40px",
          "width": "80px"
        },
        onClick: saveData
      }, {
        default: _withCtx(function () {
          return [_createTextVNode("保存")];
        }),
        _: 1
      })])])])])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
        class: "btn",
        onClick: openDialog
      }, [_createVNode(_component_van_icon, {
        name: "add-o",
        size: "15"
      }), _hoisted_6]), _createElementVNode("div", _hoisted_7, [_createVNode(_unref(Steps), {
        direction: "vertical",
        "active-color": "#969799",
        "inactive-icon": "passed",
        "active-icon": "passed"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(List), function (item, index) {
            return _openBlock(), _createBlock(_unref(Step), {
              key: index
            }, {
              "inactive-icon": _withCtx(function () {
                return [_createVNode(_component_van_icon, {
                  name: "shield-o",
                  size: "20",
                  color: "#4485f3"
                })];
              }),
              "active-icon": _withCtx(function () {
                return [_createVNode(_component_van_icon, {
                  name: "shield-o",
                  size: "20",
                  color: "#4485f3"
                })];
              }),
              default: _withCtx(function () {
                var _item$remark;
                return [_createElementVNode("div", _hoisted_8, [_createElementVNode("b", null, _toDisplayString(item.maintain_time), 1)]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("span", null, _toDisplayString(item.info), 1)]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("span", null, _toDisplayString(item.person), 1)]), _createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("span", null, _toDisplayString((_item$remark = item.remark) !== null && _item$remark !== void 0 ? _item$remark : '-'), 1)]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("span", null, _toDisplayString(item.next_time), 1)])];
              }),
              _: 2
            }, 1024);
          }), 128))];
        }),
        _: 1
      })])])])), _createVNode(_component_van_calendar, {
        color: "#4372F6",
        "default-date": _unref(defaultDay),
        show: _unref(showDate),
        "onUpdate:show": _cache[5] || (_cache[5] = function ($event) {
          return _isRef(showDate) ? showDate.value = $event : null;
        }),
        onConfirm: onConfirm
      }, null, 8, ["default-date", "show"])]);
    };
  }
};